import { useCartStore } from "../../store/cart";
import "./cart-panel.css";

function fmt(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

interface CartPanelProps {
  onCharge: () => void;
}

export function CartPanel({ onCharge }: CartPanelProps) {
  const items = useCartStore((s) => s.items);
  const changeQty = useCartStore((s) => s.changeQty);
  const clearCart = useCartStore((s) => s.clearCart);
  const cartSubtotal = useCartStore((s) => s.cartSubtotal);

  const subtotal = cartSubtotal();
  const hasItems = items.length > 0;

  return (
    <div className="cart-area">
      <div className="cart-header">
        <span className="cart-title">Cart</span>
        {hasItems && (
          <button className="cart-clear" onClick={clearCart}>
            Clear
          </button>
        )}
      </div>

      {!hasItems ? (
        <div className="cart-empty">No items — tap items above to add</div>
      ) : (
        <div className="cart-items">
          {items.map((item) => (
            <div key={item.variationId} className="cart-row">
              <span className="cart-row-name">{item.name}</span>
              <div className="cart-qty-controls">
                <button
                  className="qty-btn"
                  onClick={() => changeQty(item.variationId, -1)}
                  aria-label={`Decrease ${item.name}`}
                >
                  &#x2212;
                </button>
                <span>{item.qty}</span>
                <button
                  className="qty-btn"
                  onClick={() => changeQty(item.variationId, 1)}
                  aria-label={`Increase ${item.name}`}
                >
                  +
                </button>
              </div>
              <span className="cart-row-price">
                {fmt(item.basePriceCents * item.qty)}
              </span>
            </div>
          ))}
        </div>
      )}

      {hasItems && (
        <div className="cart-totals">
          <div className="total-row">
            <span className="lbl">Subtotal</span>
            <span>{fmt(subtotal)}</span>
          </div>
          <div className="total-row grand">
            <span>Total</span>
            <span>{fmt(subtotal)}</span>
          </div>
        </div>
      )}

      <button
        className="pay-btn"
        disabled={!hasItems}
        onClick={onCharge}
      >
        Charge &#x2192;
      </button>
    </div>
  );
}
